import { Currency, Incoterms, TradeSignalSourceType } from 'api';
import { defaultPriceIndexSchema, oneOfValidation, yup } from 'form';

export const BaseTradeSignalSchema = defaultPriceIndexSchema.shape(
  {
    created_by_id: yup.number().optional(),
    currency: yup.string().oneOf(Object.values(Currency)).required(),
    incoterm: yup.string().required().oneOf(Object.values(Incoterms)),
    notes: yup.string().optional(),
    price_as_index_percentage: yup.number().when('price_as_index_pct_enabled', {
      is: (indexPctEnabled: boolean) => {
        return indexPctEnabled;
      },
      otherwise: () => yup.number().notRequired(),
      then: () =>
        yup
          .number()
          .min(0)
          .test(
            'decimal-places',
            'Maximum 1 decimal place allowed',
            (value) => value === undefined || value === null || Number.isInteger(value * 10)
          )
          .required('This field is required'),
    }),
    price_per_tonne: yup.string().when('price_as_index_pct_enabled', {
      is: (indexPctEnabled: boolean) => {
        return !indexPctEnabled;
      },
      otherwise: () => yup.string().notRequired(),
      then: () => yup.string().required('This field is required'),
    }),
    source_type: yup.string().oneOf(Object.values(TradeSignalSourceType)).required(),
    tonnes: yup.number().typeError('Tonnes must be a number').min(10).required(),
    trade_company_id: oneOfValidation(
      [
        { label: 'Company from Ground Control', name: 'trade_company_id' },
        {
          label: 'Company from Hubspot',
          name: 'trade_company_lead_id',
        },
      ],
      () => yup.number()
    ),
    trade_company_lead_id: oneOfValidation(
      [
        {
          label: 'Company from Hubspot',
          name: 'trade_company_lead_id',
        },
        { label: 'Company from Ground Control', name: 'trade_company_id' },
      ],
      () => yup.number()
    ),
  },
  [
    ['trade_company_id', 'trade_company_lead_id'],
    ['trade_company_lead_id', 'trade_company_id'],
  ]
);
